export default {
  OPEN_COLLAPSE: 'OPEN_COLLAPSE',
  CLOSE_COLLAPSE: 'CLOSE_COLLAPSE',
  INITIALIZE_COLLAPSE: 'INITIALIZE_COLLAPSE',
  REMOVE_COLLAPSE: 'REMOVE_COLLAPSE',
}
